import React from "react";
import { useScrollLock } from "../hooks/useScrollLock";
import styles from "../styles/HowItWorksDrawPopup.module.css";

interface HowItWorksDrawPopupProps {
  isOpen: boolean;
  onClose: () => void;
  thresholds?: {
    minBnb: string;
    minDxf: string;
  };
}

const HowItWorksDrawPopup: React.FC<HowItWorksDrawPopupProps> = ({
  isOpen,
  onClose,
  thresholds,
}) => {
  useScrollLock(isOpen);

  if (!isOpen) return null;

  const minBnb = thresholds?.minBnb || '0.02';
  const minDxf = thresholds?.minDxf || '100';

  return (
    <div className={styles.howItWorksDrawOverlay}>
      <div className={styles.howItWorksDrawPopup}>
        <div className={styles.howItWorksDrawHeader}>
          <h2>How It Works</h2>
          <button onClick={onClose} className={styles.howItWorksDrawClose} type="button">
            ×
          </button>
        </div>

        <div className={styles.howItWorksDrawContent}>
          <div className={styles.howItWorksItem}>
            <h3>🎯 Daily Participation</h3>
            <p>One draw per day. Join by either starting a game OR holding at least {minBnb} BNB + {minDxf} DXF tokens.</p>
          </div>
          
          <div className={styles.howItWorksItem}>
            <h3>🎲 Fair Selection</h3>
            <p>Winners are selected using cryptographically secure random seeds that are pre-committed and later revealed.</p>
          </div>
          
          <div className={styles.howItWorksItem}>
            <h3>🏆 DXF Rewards</h3>
            <p>Winners receive 100 DXF tokens directly to their wallet. Transaction hash is recorded for transparency.</p>
          </div>
          
          <div className={styles.howItWorksItem}>
            <h3>⏰ Draw Completion</h3>
            <p>Each day's draw is completed automatically at 00:30 UTC the following day.</p>
          </div>
        </div>

        <div className={styles.howItWorksDrawFooter}>
          <button onClick={onClose} className={styles.howItWorksBtn}>
            Got it!
          </button>
        </div>
      </div>
    </div>
  );
};

export default HowItWorksDrawPopup;